var React = require('react');
var StatsTable = require('./StatsTable.jsx');
var TeamCompareHeader = require('./TeamCompareHeader.jsx');

var MatchEvents = React.createClass({
    render : function(){
        return (
            <article className="sub-module equal-height countChartList height-reset" style={{"height": "238px"}}>
                <header className="bordered"><h1>Match Events</h1></header>
                <div className="content">
                    <TeamCompareHeader bordered={'bordered'} home={this.props.home} away={this.props.away} />
                    <StatsTable stats={this.props.eventStats} />
                </div>
            </article>
        );
    }
});

module.exports = MatchEvents;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/MatchEvents.jsx
 **/